import axios from 'axios'
import { useEffect, useState } from 'react'

const TOKEN_STORAGE_KEY = 'fcm_token'

export const useWebPushToken = () => {
	const [token, setToken] = useState<string | null>(null)

	useEffect(() => {
		const savedToken = localStorage.getItem(TOKEN_STORAGE_KEY)

		if (savedToken) {
			setToken(savedToken)
		}
	}, [])

	const saveToken = (token: string) => {
		setToken(token)

		localStorage.setItem(TOKEN_STORAGE_KEY, token)
	}

	const deleteToken = () => {
		setToken(null)
		localStorage.removeItem(TOKEN_STORAGE_KEY)
	}

	const getToken = () => {
		return localStorage.getItem(TOKEN_STORAGE_KEY)
	}

	const linkTokenWithUser = async (uuid: string, phone?: string | null) => {
		try {
			await axios.post(
				`api/personal/device`,
				{
					uuid,
					os: navigator.userAgent,
					project: 'iport',
					allow_sending: true,
					...(phone && { phone })
				},
				{
					headers: {
						'Content-Type': 'application/json'
					},
					baseURL: '/'
				}
			)
		} catch (error) {
			console.error(error)
		}
	}

	return {
		token,
		saveToken,
		deleteToken,
		getToken,
		linkTokenWithUser
	}
}
